import React from "react";
import {
  Row, Col, Image, Button, Stack, InputGroup, Form, Dropdown, Nav,
  Container, DropdownButton
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../static/images/e-logo.png";
import GoogleMapModal from "./liveGmap";
import { UserIcon } from "../components/icons/icons";
import { NavLink, Link } from "react-router-dom";

const HeaderMiddle = ({
  scroll,
  selectedLocation,
  truncateName,
  setgMapModalShow,
  gMapModalShow,
  setSelectedLocation,
  availBranches,
  setAvailBranches,
  handleProductSearch,
  handleKeyPress,
  showSearch,
  searchSuggestion,
  handleAddCart,
  handleDecrement,
  handleIncrement,
  user,
  token,
  setLoginModalShow,
  cartAmount,     // optional (kept for compatibility)
  cartCount,      // optional (kept for compatibility)
  logouts,
  newRef
}) => {
  // 👇 subscribe to Redux so the header updates immediately after add-to-cart
  const storeCart = useSelector((s) => ({
    amount: s.cart.cartAmount,     // note: in your slice it's a string with toFixed(2)
    count: s.cart.cartCount,
  }));

  // Prefer props if passed explicitly, otherwise use store values
  const liveAmount = (cartAmount ?? storeCart.amount) ?? 0;
  const liveCount = (cartCount ?? storeCart.count) ?? 0;

  return (
    <Row className={`headerMain ${scroll ? "sticky" : ""}`} style={{ zIndex: "11" }}>
      <Container>
        <div className="d-flex px-md-5 px-xl-0">
          <Col md="1" className="logo">
            <Nav.Link href="/"><Image src={logo} /></Nav.Link>
          </Col>

          {/* location picker... */}
          <Col md="2" className="mt-3">
            <Stack direction="horizontal" gap={3} onClick={() => setgMapModalShow(true)}>
              <FontAwesomeIcon icon="fa-solid fa-location-dot" size="2xl" style={{ cursor: "pointer" }} />
              <Col xs="11" className="mt-1">
                <span className="w-100 float-start delito">Deliver to</span>
                {selectedLocation?.area ? (
                  <Button variant="link" className="p-0 text-decoration-none location-btn btn-bg-none loctxt">
                    {truncateName(selectedLocation.area, 8)}/{selectedLocation.pincode}
                    <FontAwesomeIcon className="ms-1" icon="fa-solid fa-angle-down" />
                  </Button>
                ) : (
                  <span style={{ color: "#ef4438", cursor: "pointer" }}>Location Not Selected</span>
                )}
              </Col>
            </Stack>
            <GoogleMapModal
              showModal={gMapModalShow}
              handleCloseModal={() => setgMapModalShow(false)}
              onLocationSelect={setSelectedLocation}
              availBranches={setAvailBranches}
            />
          </Col>

          {/* search... */}
          <Col md="6" className="d-flex align-items-center" ref={newRef}>
            <Col xs="12" className="position-relative">
              <InputGroup>
                <div className="search-icon">
                  <FontAwesomeIcon icon="fa-solid fa-search" size="1x" />
                </div>
                <Form.Control
                  type="text"
                  placeholder="Search for products..."
                  className="bg-light searchBox"
                  onChange={handleProductSearch}
                  onKeyPress={handleKeyPress}
                />
              </InputGroup>

              {showSearch && (
                <Dropdown.Menu show className="w-100 position-absolute">
                  {searchSuggestion.map((pl, index) => (
                    <Dropdown.Item key={index} as="div" className="td-none">
                      <Row>
                        <Col xs={1}>
                          <Image
                            fluid
                            src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${pl.image}`}
                            alt={pl.productName}
                          />
                        </Col>
                        <Col xs={11}>
                          <Row>
                            <Col xs={5}>
                              <span className="text-muted">{pl.brandName}</span>
                              {/* {pl.offerName && (
                                <span className="px-2 badge text-danger bg-light">
                                  {pl.offerName}
                                </span>
                              )} */}
                              <br />
                              <Link to={`/pd/${pl.slug}`} className="text-dark text-decoration-none">
                                {pl.productName}
                              </Link>
                            </Col>
                            <Col xs={2}>
                              <span className="text-muted">{pl.unit}</span>
                            </Col>
                            <Col xs={2}>Rs.{pl.salePrice?.toFixed(2)}</Col>
                            <Col xs={3} className="text-end">
                              {pl.stock > 0 ? (
                                pl.cartStatus ? (
                                  <div className="input-group variantInput">
                                    <span
                                      className="input-group-text cursor-pointer"
                                      onClick={() =>
                                        handleDecrement(pl.productItemId, pl.quantity, pl.salePrice)
                                      }
                                    >
                                      -
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control p-1 text-center"
                                      value={pl.cartQty}
                                      readOnly
                                    />
                                    <span
                                      className="input-group-text cursor-pointer"
                                      onClick={() =>
                                        handleIncrement(pl.productItemId, pl.quantity, pl.salePrice)
                                      }
                                    >
                                      +
                                    </span>
                                  </div>
                                ) : (
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    className="w-100"
                                    onClick={() =>
                                      handleAddCart(pl.productItemId, 1, pl.salePrice)
                                    }
                                  >
                                    + Add
                                  </Button>
                                )
                              ) : (
                                <Button variant="danger" size="sm" className="w-100" disabled>
                                  Out of Stock
                                </Button>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              )}
            </Col>
          </Col>

          {/* account + cart */}
          <Col md="3" className="d-flex align-items-center">
            <Col className="col-xl-8">
              <Stack className="ps-3 justify-content-center" direction="horizontal">
                <UserIcon />
                {!user || !token ? (
                  <Button variant="link" className="p-0 ULText text-decoration-none btn-bg-none" onClick={() => setLoginModalShow(true)}>
                    Login / register
                  </Button>
                ) : (
                  <DropdownButton
                    className="userDropDown"
                    id="dropdown-item-button"
                    title={user.name ? user.name : "View Account"}
                  >
                    <NavLink className="dropdown-item h-b" to="/profile">
                      <FontAwesomeIcon icon="fa-solid fa-user" size="1x" />{" "}
                      &nbsp; Profile
                    </NavLink>
                    <NavLink className="dropdown-item h-b" to="/profile/myorders">
                      <FontAwesomeIcon icon="fa-solid fa-bag-shopping" size="1x" />{" "}
                      &nbsp; My Orders
                    </NavLink>
                    <NavLink className="dropdown-item h-b" to="/profile/address">
                      <FontAwesomeIcon icon="fa-regular fa-address-card" size="1x" />{" "}
                      &nbsp; Shipping Address
                    </NavLink>
                    <NavLink className="dropdown-item h-b" to="/profile/password">
                      <FontAwesomeIcon icon="fa-solid fa-lock" size="1x" />{" "}
                      &nbsp; Change Password
                    </NavLink>
                    <NavLink className="dropdown-item h-b" to="/profile/notification">
                      <FontAwesomeIcon icon="fa-regular fa-bell" size="1x" />{" "}
                      &nbsp; Notification
                    </NavLink>
                    <Dropdown.Item as="button" onClick={logouts}>
                      <FontAwesomeIcon icon="fa-solid fa-arrow-right-from-bracket" size="1x" />{" "}
                      &nbsp; Logout
                    </Dropdown.Item>
                  </DropdownButton>
                )}
              </Stack>
            </Col>

            <Col className="col-xl-4 d-flex align-items-center justify-content-end">
              <Nav.Link href="/cart">
                <Stack direction="horizontal" gap={1}>
                  <div className="ciDiv">
                    <FontAwesomeIcon icon="fa-solid fa-cart-shopping" size="xl" />
                  </div>
                  <div>
                    <span className="w-100 float-start color-primary hpriceTxt">
                      ₹{Number(liveAmount).toFixed ? Number(liveAmount).toFixed(2) : liveAmount}
                    </span>
                    <span className="hitemTxt w-100 ">{liveCount}&nbsp;items</span>
                  </div>
                </Stack>
              </Nav.Link>
            </Col>
          </Col>
        </div>
      </Container>
    </Row>
  );
};

export default HeaderMiddle;
